import React from 'react';
import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const ConfirmationModal = ({ setShowModal, showModal, onAccept, message }) => {

    const onOk = () => {
        setShowModal(false);
        onAccept();  // Execute the accept action when "Ok" is clicked
    };

    const onCancel = () => {
        setShowModal(false);  // Close the modal without any action when "Cancel" is clicked
    };

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
            color="success"
            className="rounded-3 me-2"
            onClick={onOk}
            label="Guardar"
            outline={true}
            icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
            color="danger"
            className="rounded-3 me-3"
            onClick={onCancel}
            label="Cancelar"
            outline={true}
            icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
            <h4 className="text-primary m-0 ps-4">Actualizar Estatus</h4>
            </label>
        </div>
    )

    // The modal content (children)
    const childrenBody = (
        <>
            <GradientDecorationLine />

            <div className="px-4">
            <label className="text-primary">{message}</label>
            <br />
            </div>

            <GradientDecorationLine />

            <div className="page-title-box d-flex justify-content-end">
            {buttons}
            </div>
        </>
    );

    return (
        <BaseCustomModal
            title={title}               // We handle the title in the childrenBody
            isModalOpen={showModal}    // Controls modal open/close state
            handleOk={onOk}           // Handles the "Ok" action
            handleCancel={onCancel}   // Handles the "Cancel" action
            footer={null}              // Custom footer inside the modal
            afterClose={() => setShowModal(false)}  // Ensures modal is closed after closing animation
        >
            {childrenBody}
        </BaseCustomModal>
    );
};
